export const tableData = [
    {
        id: 16,
        telegramId: -1002438909755,
        username: 'testtgbb',
        name: 'test-tgb',
        membersCount: 5,
        photoUrl: null,
        createdAt: '2025-07-12T13:44:41.029Z',
        updatedAt: '2025-07-12T13:44:41.045Z',
        role: 'owner',
        tgRole: 'owner',
        timezone: 'Africa/Abidjan',
        language: 'russian',
        country: 'ru',
        category: '32',
        type: 'channel',
        url: null,
        visibleForPartners: true,
        isFake: false,
        membersCount: 93000,
        type: 'Фикс',
        averageCoverage: 444,
        growth30: 999,
        cost: 2222
    },
    {
        id: 17,
        telegramId: -1002438909755,
        username: 'testtgbb',
        name: 'test-tgb',
        membersCount: 5,
        photoUrl: null,
        createdAt: '2025-07-12T13:44:41.029Z',
        updatedAt: '2025-07-12T13:44:41.045Z',
        role: 'owner',
        tgRole: 'owner',
        timezone: 'Africa/Abidjan',
        language: 'russian',
        country: 'ru',
        category: '32',
        type: 'channel',
        url: null,
        visibleForPartners: true,
        isFake: false,
        membersCount: 93000,
        type: 'Фикс',
        averageCoverage: 444,
        growth30: 999,
        cost: 2222
    }
]
